/*@ngInject*/
module.exports = function() {
    return {
        scope: {
            object: '=',
            objectForm: '=',
            showErrors: '=',
            name: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function(sharedService) {
            let vm = this;

            vm.phonePattern = sharedService.getPhonePattern();
            vm.emailPattern = sharedService.getEmailPattern();
            vm.websitePattern = sharedService.getWebsitePattern();

            vm.$onInit = function() {
                vm.title = 'Objekti üldinfo';
                vm.serviceTypes = vm.classifiers ? vm.classifiers.serviceTypes : {};
                for(let index in vm.object.version.name) {
                    const name = vm.object.version.name[index];
                    vm.name[name.language] = name;
                }
            };

            vm.nameEstChanged = function() {
                const estName = vm.name.est.value;
                for(let language in vm.name) {
                    let name = vm.name[language];
                    if(!name.value) {
                        name.value = estName;
                    }
                }
            };

            vm.getTypeName = function() {
                let name = '';
                for(let i = 0; i < vm.serviceTypes.length; i++) {
                    if(vm.serviceTypes[i].id === vm.object.version.type_id) {
                        name = vm.serviceTypes[i].name;
                        break;
                    }
                }
                return name;
            };
        },

        template: require('./objects-edit-main.html')
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/objects/edit/directives/objects-edit-main.directive.js
 **/